import useSWR from 'swr'
import { guardClient } from '../_axios'

export type SettingsTargets = {
  monthlySalesTarget: number
  yearlySalesTarget: number
  fiscalStartMonth: 1 | 4
}

type SettingsResponse = {
  data: SettingsTargets
}

const settingsFetcher = async (_urlTail: string): Promise<SettingsResponse> => {
  // const response = await guardClient.get<SettingsResponse>(_urlTail).then((r) => r.data)
  void guardClient

  return Promise.resolve({
    data: {
      monthlySalesTarget: 180000000,
      yearlySalesTarget: 2160000000,
      fiscalStartMonth: 4
    }
  })
}

export const useSettings = () => {
  const path = '/company/settings'
  const { data, mutate } = useSWR(path, settingsFetcher, {
    onErrorRetry: () => {
      return
    }
  })

  return { data: data?.data, mutate }
}
